export const PROVINCE_SAVE = 'PROVINCE_SAVE';
